import type { Error } from '@/views/apps/_customPage/types'
import { type ExtendedBlock, type ListView } from 'widget-components'
import type { Ref } from 'vue'
import { path } from 'ramda'
import { useI18n } from '@/composables/i18n'
import { updateBlock } from 'widget-components/integrations/CustomPage/blocks-state'

const translateErrorCode = (errorCode: string, block: ExtendedBlock) => {
    const { t } = useI18n()
    return t(`error.${errorCode}`, {
        value: path(['currentValue'], block),
        min: path(['min'], block),
        max: path(['max'], block),
        length: path(['length'], block),
    })
}

const isListView = (block: ExtendedBlock): block is ExtendedBlock<ListView> => block.type === 'LIST_VIEW'

export const handleComponentErrors = (flattenedBlocks: Ref<ExtendedBlock[]>, errors: Error[]): void => {
    const isCp2 = flattenedBlocks.value[0].type === 'CONTAINER'

    if (isCp2) {
        errors.forEach(error => {
            const block = flattenedBlocks.value.find(block => block.id === error.componentIndex)
            if (!block) {
                return
            }
            updateBlock({
                ...block,
                error: error.message || translateErrorCode(error.code, block),
            })
        })

        return
    }

    errors.forEach(error => {
        const [blockId, listViewIndex, listViewComponentId] = (error.componentIndex ?? '').split('.')

        const blockIndex = flattenedBlocks.value.findIndex(block => block.id === blockId)
        const block = flattenedBlocks.value[blockIndex]

        if (!block) {
            return
        }

        if (isListView(block) && listViewIndex) {
            const itemIndex = block.items.findIndex(item => String(item.index) === listViewIndex)
            const item = block.items[itemIndex]
            const component = item?.components.find(component => component.id === listViewComponentId)

            if (component) {
                component.error = error.message || translateErrorCode(error.code, component)
                return
            }
        }

        updateBlock({
            ...block,
            error: error.message || translateErrorCode(error.code, block),
        })
    })
}
